import React, { Component } from 'react';

import {
  withRouter
} from 'react-router-dom';

import { Page, Text, Card, Icon, Badge, Banner, Modal, Link, BlockStack, Button, Thumbnail, Popover, ActionList, TextField, Select, DropZone } from '@shopify/polaris';
import {
  ArrowRightMinor,
  // LockMajor,
  MobileHorizontalDotsMajor,
  NoteMajor
} from '@shopify/polaris-icons';
import './index.css';

import {
  reqGetJsonLdDataV2,
  reqInsertCreateCampaignImage,
  reqSaveJsonLdV2,
  reqUpSwitchJsonLdSwitchV2
} from '../../../api';

import Switch from "react-switch";
import { connect } from 'react-redux'
import { setPageData } from '../../../redux/actions/getAppPageData';
import utils from '../../../utils/utils';
// 翻译
import Language from '../../../i18n/Language';
import SkeltonLoading from '../../../components/SkeltonLoading';
import FaqCardBox from '../../../components/FaqCardBox';
import ViewImage from '../../../components/ViewImage';
import { LocalBusinessTypeAndSpecialType } from '../SnippetsJSONLD/index/components/constants';
import SaveBarTop from '../../../components/SaveBarTop';
import { cloneDeep } from 'lodash';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language

class indexClass extends Component {

  state = {
    localBusinessStatus: false, // 开关状态
    loadingText: {}, // loading按钮
    loadingSwitch: true, // 开关loading
    resData: {}, // 接口数据

    questionList: {
      // w_local: {
      //   title: "What is JSON-LD for Local Business?",
      //   tag: ["JSON-LD for Local Business is a structured data format used to identify and describe relevant information about local businesses on web pages, such as name, address, phone number, business hours, etc."]
      // },
      // wi_local: {
      //   title: "What information should be included in Local Business JSON-LD?",
      //   tag: ["Local Business JSON-LD should include key information about the local business, such as name, address, phone number, business hours, business scope, location coordinates, etc., to ensure correct parsing and display by search engines and other applications."]
      // },
      // hta_local: {
      //   title: "How to add Local Business JSON-LD to a web page?",
      //   tag: ["Add the information in the list and toggle the switch to enable it. SEOAnt will automatically allocate the data to be displayed in search engines."]
      // },
      // is_local: {
      //   title: "Is Local Business JSON-LD suitable for all types of local businesses?",
      //   tag: ["Yes, Local Business JSON-LD is suitable for various types of local businesses, including restaurants, retail stores, service industries, etc."]
      // },
      // hd_local: {
      //   title: "How does JSON-LD help local businesses rank higher in search engines?",
      //   tag: ["By providing structured local business information, search engines can more accurately understand webpage content and display local business information in relevant search results, thereby improving the business's ranking in local search results."]
      // },
      // htv_local: {
      //   title: "How to validate the effectiveness of Local Business JSON-LD?",
      //   tag: ["Various structured data testing tools or the Google Structured Data Testing Tool can be used to validate the syntax and structure of Local Business JSON-LD. The URL for the tool is https://search.google.com/test/rich-results."]
      // }
      w_localb: {
        title: "What is JSON-LD for Local Business?",
        tag: ["JSON-LD structures local business data (name, address, phone, hours) into machine-readable markup, enhancing search engine understanding and display in results."]
      },
      is_localb: {
        title: "Is Local Business JSON-LD suitable for all types of local businesses?",
        tag: ["Yes, Local Business JSON-LD is suitable for various types of local businesses, including restaurants, retail stores, service industries, etc."]
      },
      h_localb: {
        title: "How does JSON-LD help local businesses rank higher in search engines?",
        tag: ["By structuring business details (name, address, hours) into machine-readable data, enabling search engines to better comprehend, highlight in rich snippets/map features, and prioritize results for relevant queries."]
      }
    },
    imgUrl: '', // 预览图片链接
    level: 1,
    localState: false,
    resInfo: {},
    action: 'localBusiness',
    local_business_type: '',
    local_specific_type: '',
    image_url: '',
    business_name: '',
    review_rating: '',
    telephone: '',
    price_range: '',
    streetAddress: '',
    postalCode: '',
    addressLocality: '',
    addressCountry: '',
    addressRegion: '',
    latitude: '',
    longitude: '',
    mon_time: '',
    tue_time: '',
    wed_time: '',
    thu_time: '',
    fri_time: '',
    sat_time: '',
    sun_time: '',
    //参数初始化
    localTypeOoptions: [],
    specificTypeOoptions: [],
    timeState: false,
    editStoreState: false,
    editHoursState: false,
    loading: true,
    loadingPage: true,
    // 保存按钮加载状态
    firstSaveButtonLoading: false,
    //图片删除按钮
    imgButtonHero: true,
    isUploadStatus: false,
    isShowSaveBar: false,
    originData: {},
  }

  UNSAFE_componentWillMount() {
    // 进入重新置空
    // updateCount = 0;
  }

  componentDidMount() {
    // 判断是否已经缓存到redux中 如果缓存了则使用缓存的值
    let _page = this.props.page;
    let _store = this.props.public;
    this.setState({
      level: _store.level
    }, () => {
      let res = _page.pageInit?.LocalBusiness;
      this.getSwitchStatus(res)
    })
  }

  /**
 * 获取开关状态
 */
  getSwitchStatus = async (_reduxData = null) => {
    this.setState({
      loading: true,
      loadingSwitch: true,
    })
    let response = '';
    if (_reduxData) {
      response = _reduxData;
    } else {
      response = await reqGetJsonLdDataV2()
    }
    if (response.ack === 1) {
      if (_reduxData) {
        this.getSwitchStatus();
      }
      // 判断是否第一次 第一次则缓存
      this.props.getPageDataRedux(response);
      let resData = response.data
      let _local = resData.local_business_data;
      this.setState({
        localBusinessStatus: Boolean(resData.local_business_switch),
        richResultsUrl: resData.domain,
        logo_url: resData.logo_url,
        organization_name: resData.organization_name,
        social_media_data: resData.social_media_data,
        local_business_data: resData.local_business_data,
        loading: false,
        loadingPage: false,
        resData: response,
        resInfo: resData,

        originData: _local,
        local_business_type: _local.local_business_type,
        image_url: _local.image_url,
        business_name: _local.business_name,
        review_rating: _local.review_rating,
        telephone: _local.telephone,
        price_range: _local.price_range,
        streetAddress: _local.streetAddress,
        postalCode: _local.postalCode,
        addressLocality: _local.addressLocality,
        addressCountry: _local.addressCountry,
        addressRegion: _local.addressRegion,
        latitude: _local.latitude,
        longitude: _local.longitude,
        mon_time: _local.mon_time,
        tue_time: _local.tue_time,
        wed_time: _local.wed_time,
        thu_time: _local.thu_time,
        fri_time: _local.fri_time,
        sat_time: _local.sat_time,
        sun_time: _local.sun_time,
      }, () => {
        this.initData() // 执行完毕后初始化数据
      })
    } else {
      this.props.toggleToast(response.msg, true)
    }

    if (!Boolean(_reduxData)) {
      this.setState({
        loadingSwitch: false,
      })
    }
  }

  // 初始化分类数据
  initData = () => {
    let localTypeOoptions = [];
    let specificTypeOoptions = [];
    Object.keys(LocalBusinessTypeAndSpecialType).forEach((key) => {
      localTypeOoptions = [...localTypeOoptions, { label: LocalBusinessTypeAndSpecialType[key].name, value: LocalBusinessTypeAndSpecialType[key].name }];
    });

    this.setState({ localTypeOoptions: localTypeOoptions }, () => {
      Object.keys(LocalBusinessTypeAndSpecialType).forEach((key) => {
        if (LocalBusinessTypeAndSpecialType[key].name === this.state.local_business_type) {
          if (LocalBusinessTypeAndSpecialType[key]?.children) {
            Object.keys(LocalBusinessTypeAndSpecialType[key].children).forEach((ckey) => {
              specificTypeOoptions = [...specificTypeOoptions, { label: LocalBusinessTypeAndSpecialType[key].children[ckey].name, value: LocalBusinessTypeAndSpecialType[key].children[ckey].name }];
            });
            this.setState({
              specificTypeOoptions: specificTypeOoptions,
            })
          } else {
            this.setState({
              specificTypeOoptions: [],
              local_specific_type: '', // 第二个选项置为空
            })
          }
        }
      });
      if (this.state.local_business_type === "") {
        if (localTypeOoptions) {
          this.setState({
            local_business_type: localTypeOoptions[0].value
          })
        } else {
          this.setState({
            local_business_type: specificTypeOoptions[0].value
          })
        }
      }
    });
  }

  // 开关
  switchOragnizeState = (name) => {
    const state = this.state;
    let { level } = this.state;
    if (level === 1 && !state[name]) {
      this.props.show();
    } else {
      this.setState({
        loadingSwitch: true,
      })
      const compareField = {
        'localBusinessStatus': 'local_business_switch'
      }
      this.setState({
        [name]: !state[name]
      }, () => {
        let params = {
          action: compareField[name],
          value: Number(!state[name])
        };
        this.updateSwitchStatus(params, name).then((result) => {
          if (!result) {
            this.setState({
              [name]: state[name],
            })
          }
        })

      })
    }
  }

  //更新开关状态
  updateSwitchStatus = async (params, name) => {
    let response = '';
    response = await reqUpSwitchJsonLdSwitchV2(params);
    if (response) {
      this.setState({
        loadingSwitch: false,
      })
    }
    if (response.code === 201) {
      this.props.toggleToast(response.msg, true)
      this.setState({
        showBanner: true,
        clickHereUrl: response.data.url,
      }, () => {
        this.toggleTipModalActive(false)
      })

      // return false
    }
    if (response.code === '1000') {
      this.props.show()
      // return false
    }
    if (response.ack === 1) {
      this.props.toggleToast(response.msg, false)
      this.setState({
        showBanner: false,
        clickHereUrl: "",
      })
      // return true
    } else {
      this.props.toggleToast(response.msg, true)
      // return false
    }

    return response.ack === 1 ? true : false
  }

  // 跳转外链
  jumpOutUrl = () => {
    window.open(`https://search.google.com/test/rich-results/result?url=${this.state.richResultsUrl}`)
  }

  // 返回
  goBack = () => {
    utils.routeJump(this, '/searchAppearance')
  }

  // 预览图片
  viewImageShow = () => {
    this.setState({
      imgUrl: '/imgJsonLD/local-business03.png',
    })
  }

  // 关闭
  closeImageShow = () => {
    this.setState({
      imgUrl: ''
    })
  }

  // 编辑弹窗
  toggleStoreEdit = () => {
    let { editStoreState } = this.state;
    this.resetFormData();
    this.setState({
      editStoreState: !editStoreState,
      localState: false,
    })
  }

  // 编辑弹窗
  toggleHoursEdit = () => {
    let { editHoursState } = this.state;
    this.resetFormData();
    this.setState({
      editHoursState: !editHoursState,
      timeState: false,
    })
  }

  resetFormData = () => {
    let { resInfo, uploadedFilesHero } = this.state;
    let _local = resInfo.local_business_data;
    this.setState({
      image_url: _local.image_url,
      business_name: _local.business_name,
      review_rating: _local.review_rating,
      telephone: _local.telephone,
      price_range: _local.price_range,
      streetAddress: _local.streetAddress,
      postalCode: _local.postalCode,
      addressLocality: _local.addressLocality,
      addressCountry: _local.addressCountry,
      addressRegion: _local.addressRegion,
      latitude: _local.latitude,
      longitude: _local.longitude,
      mon_time: _local.mon_time,
      tue_time: _local.tue_time,
      wed_time: _local.wed_time,
      thu_time: _local.thu_time,
      fri_time: _local.fri_time,
      sat_time: _local.sat_time,
      sun_time: _local.sun_time,
      uploadedFilesHero: _local.image_url ? uploadedFilesHero : null,
      isUploadStatus: false,
      imgButtonHero: !Boolean(_local.image_url),
    }, () => {
      this.setUpdateImageHero(1, 0, _local.image_url);
    })
  }

  updateFormData = () => {
    let { resInfo, image_url, business_name, review_rating, telephone, price_range, streetAddress, postalCode, addressLocality, addressCountry, addressRegion, latitude, longitude, mon_time, tue_time, wed_time, thu_time, fri_time, sat_time, sun_time, uploadedFilesHero } = this.state;
    let newResinfo = cloneDeep(resInfo);
    let _local = newResinfo.local_business_data;
    _local.image_url = image_url;
    _local.business_name = business_name;
    _local.review_rating = review_rating;
    _local.telephone = telephone;
    _local.price_range = price_range;
    _local.streetAddress = streetAddress;
    _local.postalCode = postalCode;
    _local.addressLocality = addressLocality;
    _local.addressCountry = addressCountry;
    _local.addressRegion = addressRegion;
    _local.latitude = latitude;
    _local.longitude = longitude;
    _local.mon_time = mon_time;
    _local.tue_time = tue_time;
    _local.wed_time = wed_time;
    _local.thu_time = thu_time;
    _local.fri_time = fri_time;
    _local.sat_time = sat_time;
    _local.sun_time = sun_time;
    this.setState({
      resInfo: newResinfo,
      uploadedFilesHero: image_url ? uploadedFilesHero : null,
      isUploadStatus: false,
      imgButtonHero: !Boolean(image_url),
    })
  }

  // 分类关联数据联动
  handleLocalBusinessTypeInputChange = (value, name) => {
    let specificTypeOoptions = [];
    this.setState({
      [name]: value,
      initBtnSave: false,
    }, () => {
      Object.keys(LocalBusinessTypeAndSpecialType).forEach((key) => {
        if (LocalBusinessTypeAndSpecialType[key].name === value) {
          if (LocalBusinessTypeAndSpecialType[key]?.children) {
            Object.keys(LocalBusinessTypeAndSpecialType[key].children).forEach((ckey) => {
              specificTypeOoptions = [...specificTypeOoptions, { label: LocalBusinessTypeAndSpecialType[key].children[ckey].name, value: LocalBusinessTypeAndSpecialType[key].children[ckey].name }];
            });
            this.setState({
              specificTypeOoptions: specificTypeOoptions,
              local_specific_type: specificTypeOoptions[0].value, // 第二个选项职位第一个值
            })
          } else {
            this.setState({
              specificTypeOoptions: [],
              local_specific_type: '', // 第二个选项置为空
            })
          }
        }
      });

      this.checkDataChange();
    });
  }

  // business hours 时间input 框
  handleCheckInputChange = (value, name) => {
    let arr1 = [];
    arr1 = name.split('.')
    const state = this.state;
    this.setState({
      [arr1[0]]: { ...state[arr1[0]], [arr1[1]]: value },
      initBtnSave: false,
    }, () => { })
  }

  handleInputChange = (value, name) => {
    this.setState({
      [name]: value,
      initBtnSave: false,
    }, () => {
      this.checkDataChange();
    })
  }

  // 检测是否发生更改
  checkDataChange = () => {
    let { originData, telephone, price_range, review_rating, local_business_type, localTypeOoptions } = this.state;
    let _t = originData;
    let localType = local_business_type || localTypeOoptions[0].value;
    let _state = _t.telephone !== telephone || _t.price_range !== price_range || _t.review_rating !== review_rating || _t.local_business_type !== localType;
    this.setIsShowBarState(_state);
  }

  //更新数据
  updateStructuredData = async () => {
    this.setState({
      firstSaveButtonLoading: true
    }, async () => {
      const state = this.state;
      let params = {};
      let response = '';
      params = {
        action: 'localBusiness',
        local_business_type: state.local_business_type,
        local_specific_type: state.local_specific_type,
        image_url: state.image_url,
        business_name: state.business_name,
        review_rating: state.review_rating,
        telephone: state.telephone,
        price_range: state.price_range,
        streetAddress: state.streetAddress,
        postalCode: state.postalCode,
        addressLocality: state.addressLocality,
        addressCountry: state.addressCountry,
        addressRegion: state.addressRegion,
        latitude: state.latitude,
        longitude: state.longitude,
        mon_time: state.mon_time,
        tue_time: state.tue_time,
        wed_time: state.wed_time,
        thu_time: state.thu_time,
        fri_time: state.fri_time,
        sat_time: state.sat_time,
        sun_time: state.sun_time,
      };
      response = await reqSaveJsonLdV2(params)
      if (response) {
        this.setState({
          firstSaveButtonLoading: false,
          editStoreState: false,
          editHoursState: false,
        });
      }
      if (response.code === '1000') {
        this.props.show();
        return false;
      }
      if (response.ack === 1) {
        let { originData } = this.state;
        let newOrigin = cloneDeep(originData);
        newOrigin.telephone = state.telephone;
        newOrigin.price_range = state.price_range;
        newOrigin.review_rating = state.review_rating;
        newOrigin.local_business_type = state.local_business_type;
        this.setIsShowBarState(false);
        this.setState({
          initBtnSave: true,
          originData: newOrigin,
        }, () => {
          this.updateFormData();
        })
        this.props.toggleToast(response.msg, false);
      } else {
        this.props.toggleToast(response.msg, true);
      }
      return;
    });
  }

  // 监听点击上传
  uploadImageData = () => {
    let objClick = document.querySelector('.Polaris-DropZone')
    if (Boolean(objClick)) {
      objClick.click();
    }
  }

  //删除图片
  deleteImageHero = () => {
    this.setState({
      filesHero: '',
      imgButtonHero: true,
      image_url: '',
      initBtnSave: false,
    });
    this.setUpdateImageHero();
  }

  //设置图片
  setUpdateImageHero = async (type, acceptedFiles, img) => {
    this.setState({ isUploadStatus: true })
    var fileUpload = '';
    var uploadedFiles = '';
    var image = "";
    if (img) {
      fileUpload = !img && <DropZone.FileUpload actionTitle="Accepts .jpg, and .png" />;
      uploadedFiles = img && (
        <div className="addImage">
          <Thumbnail
            size="small"
            alt=''
            source={img}
          />
        </div>
      );
      this.setState({
        imgButtonHero: false,
        fileUploadHero: fileUpload,
        uploadedFilesHero: uploadedFiles,
        isUploadStatus: false
      });
    } else if (acceptedFiles) {
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      const filesImg = acceptedFiles
      if (validImageTypes.indexOf(filesImg.type) >= 0) {
        fileUpload = !filesImg && <DropZone.FileUpload />;

        //开启FileReader
        var reader = new FileReader();
        reader.readAsDataURL(filesImg); //读取文件保存在result中
        reader.onload = (e) => {
          var getRes = e.target.result;//读取的结果在result中
          const params = { img: getRes, type: filesImg.type };
          reqInsertCreateCampaignImage(params).then(response => {
            if (response.code === '200') {
              uploadedFiles = filesImg && (
                <div className="addImage">
                  <Thumbnail
                    size="small"
                    alt={filesImg.name}
                    source={response.data}
                  />
                </div>
              );
              image = response.data;
            } else {
              fileUpload = <DropZone.FileUpload />;
              uploadedFiles = '';
              this.setState({
                isShowGifBanner: typeof response.data === 'string' ? response.data : response.msg,
              })
            }

            this.setState({
              imgButtonHero: false,
              fileUploadHero: fileUpload,
              uploadedFilesHero: uploadedFiles,
              image_url: image,
              isUploadStatus: false
            });
          })
        }
      } else {
        fileUpload = <DropZone.FileUpload />;
        uploadedFiles = ''
        this.setState({
          fileUploadHero: fileUpload,
          uploadedFilesHero: uploadedFiles,
          image_url: image,
          isUploadStatus: false
        });
      }
    } else {
      fileUpload = <DropZone.FileUpload />;
      uploadedFiles = ''
      this.setState({
        fileUploadHero: fileUpload,
        uploadedFilesHero: uploadedFiles,
        image_url: image,
        isUploadStatus: false
      });
    }
  }

  //上传图片
  updateImageHero = (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      this.setState({
        isShowGifBanner: "Only accepts .jpg, .jpeg and .png"
      })
    } else {
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      if (!validImageTypes.includes(acceptedFiles[0].type)) {
        this.setState({
          isShowGifBanner: "Only accepts .jpg, .jpeg and .png"
        })
      } else {
        this.setState({
          filesHero: acceptedFiles[0],
          initBtnSave: false,
        });

        this.setUpdateImageHero(1, acceptedFiles[0]);
      }
    }
  }

  // 舍弃
  handleShopifyDiscard = () => {
    let { originData, localTypeOoptions } = this.state;
    let _t = originData;
    this.setIsShowBarState(false);
    this.setState({
      telephone: _t.telephone,
      price_range: _t.price_range,
      review_rating: _t.review_rating,
      local_business_type: _t.local_business_type || localTypeOoptions[0].value,
    })
  }

  // 设置savebar状态
  setIsShowBarState = (_state) => {
    window.savebarState = _state;
    this.setState({
      isShowSaveBar: _state
    })
  }

  render() {
    const {
      state: {
        localBusinessStatus,
        loadingSwitch,
        // resData,
        questionList,
        imgUrl,
        // level,
        localState,
        // resInfo,

        local_business_type,
        localTypeOoptions,
        image_url,
        business_name,
        review_rating,
        telephone,
        price_range,
        streetAddress,
        postalCode,
        addressLocality,
        addressCountry,
        addressRegion,
        latitude,
        longitude,
        mon_time,
        tue_time,
        wed_time,
        thu_time,
        fri_time,
        sat_time,
        sun_time,
        timeState,
        editStoreState,
        editHoursState,
        firstSaveButtonLoading,
        isShowSaveBar,

      },

    } = this;

    const EditStoreModal = <Modal
      open={editStoreState}
      title={t("Edit store details")}
      primaryAction={{
        content: t("Save"),
        onAction: this.updateStructuredData,
        loading: firstSaveButtonLoading,
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: this.toggleStoreEdit,
        }
      ]}
      onClose={this.toggleStoreEdit}
    >
      <Modal.Section>
        <BlockStack gap={200}>
          <div className='local_edit flex_layout'>
            <div className='logoOrg flex_layout'>
              <div className='uploadOrgImg'>
                <DropZone
                  accept="image/*"
                  type="image"
                  onDrop={(files, acceptedFiles, rejectedFiles) => {
                    this.updateImageHero(acceptedFiles)
                  }}
                >
                  {!this.state.uploadedFilesHero && <div className='add_file_icon'>
                    <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 6C10.3284 6 11 5.32843 11 4.5C11 3.67157 10.3284 3 9.5 3C8.67157 3 8 3.67157 8 4.5C8 5.32843 8.67157 6 9.5 6Z" fill="#8A8A8A" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M6.0179 0.5H7.98211C8.79494 0.499993 9.45056 0.499987 9.98147 0.543364C10.5281 0.588026 11.0082 0.682385 11.4525 0.908726C12.1581 1.26825 12.7317 1.84193 13.0913 2.54754C13.3176 2.99175 13.412 3.4719 13.4566 4.01853C13.5 4.54944 13.5 5.20505 13.5 6.01788V7.98212C13.5 8.79496 13.5 9.45056 13.4566 9.98147C13.412 10.5281 13.3176 11.0082 13.0913 11.4525C12.7317 12.1581 12.1581 12.7317 11.4525 13.0913C11.0082 13.3176 10.5281 13.412 9.98147 13.4566C9.45056 13.5 8.79495 13.5 7.98212 13.5H6.01788C5.20505 13.5 4.54944 13.5 4.01853 13.4566C3.4719 13.412 2.99175 13.3176 2.54754 13.0913C1.84193 12.7317 1.26825 12.1581 0.908726 11.4525C0.682385 11.0082 0.588026 10.5281 0.543364 9.98147C0.499987 9.45056 0.499993 8.79495 0.5 7.98212V6.0179C0.499993 5.20506 0.499987 4.54944 0.543364 4.01853C0.588026 3.4719 0.682385 2.99175 0.908726 2.54754C1.26825 1.84193 1.84193 1.26825 2.54754 0.908726C2.99175 0.682385 3.4719 0.588026 4.01853 0.543364C4.54944 0.499987 5.20506 0.499993 6.0179 0.5ZM4.14068 2.03838C3.68681 2.07547 3.42604 2.1446 3.22852 2.24524C2.80516 2.46095 2.46095 2.80516 2.24524 3.22852C2.1446 3.42604 2.07547 3.68681 2.03838 4.14068C2.00058 4.60331 2 5.19755 2 6.05V7.4785L2.7228 6.61114C3.38159 5.82059 4.57697 5.76637 5.30462 6.49402L7.99999 9.18939L9.17963 8.00974C9.91716 7.27222 11.132 7.3395 11.7836 8.15396L11.9997 8.42404C12 8.27538 12 8.11768 12 7.95V6.05C12 5.19755 11.9994 4.60331 11.9616 4.14068C11.9245 3.68681 11.8554 3.42604 11.7548 3.22852C11.539 2.80516 11.1948 2.46095 10.7715 2.24524C10.574 2.1446 10.3132 2.07547 9.85932 2.03838C9.39669 2.00058 8.80245 2 7.95 2H6.05C5.19755 2 4.60331 2.00058 4.14068 2.03838ZM2.03838 9.85932C2.03622 9.83282 2.03417 9.80589 2.03225 9.7785C2.04743 9.76317 2.06209 9.74707 2.07615 9.73019L3.87513 7.57141C3.96924 7.45848 4.14001 7.45073 4.24396 7.55468L7.46966 10.7804C7.76255 11.0733 8.23742 11.0733 8.53032 10.7804L10.2403 9.0704C10.3457 8.96504 10.5192 8.97465 10.6123 9.09101L11.8252 10.6071C11.8037 10.6674 11.7803 10.7214 11.7548 10.7715C11.539 11.1948 11.1948 11.539 10.7715 11.7548C10.574 11.8554 10.3132 11.9245 9.85932 11.9616C9.39669 11.9994 8.80245 12 7.95 12H6.05C5.19755 12 4.60331 11.9994 4.14068 11.9616C3.68681 11.9245 3.42604 11.8554 3.22852 11.7548C2.80516 11.539 2.46095 11.1948 2.24524 10.7715C2.1446 10.574 2.07547 10.3132 2.03838 9.85932Z" fill="#8A8A8A" />
                    </svg>
                  </div>}
                  {this.state.uploadedFilesHero}
                </DropZone>
              </div>
              <div className='update-images-button'>
                <Button size='slim' onClick={this.uploadImageData} outline loading={this.state.isUploadStatus}>{t("Upload photo")}</Button>
                {
                  (this.state.imgButtonHero || this.state.isUploadStatus || this.state.firstSaveButtonLoading) ? null :
                    <Button size='slim' disabled={this.state.imgButtonHero || this.state.isUploadStatus || this.state.firstSaveButtonLoading} onClick={() => this.deleteImageHero()} outline>{t("Remove")}</Button>
                }
              </div>
            </div>
            <TextField
              type="text"
              label={t("Business name")}
              value={business_name}
              id="business_name"
              onChange={this.handleInputChange}
            />
          </div>
          <TextField
            type="tel"
            label={t("Country")}
            value={addressCountry}
            id="addressCountry"
            onChange={this.handleInputChange}
          />
          <div className='local_edit Form-input-flex'>
            <TextField
              type="text"
              label={t("City")}
              value={addressLocality}
              id="addressLocality"
              onChange={this.handleInputChange}
            />
            <TextField
              type="tel"
              label={t("State/Province")}
              value={addressRegion}
              id="addressRegion"
              onChange={this.handleInputChange}
            />
          </div>
          <TextField
            type="text"
            label={t("Street address")}
            value={streetAddress}
            id="streetAddress"
            onChange={this.handleInputChange}
          />
          <div className='local_edit Form-input-flex'>
            <TextField
              type="text"
              label={t("Zip/Postal code")}
              value={postalCode}
              id="postalCode"
              onChange={this.handleInputChange}
            />
            <TextField
              type="text"
              label={t("Latitude")}
              value={latitude}
              id="latitude"
              onChange={this.handleInputChange}
            />
            <TextField
              type="text"
              label={t("Longitude")}
              value={longitude}
              id="longitude"
              onChange={this.handleInputChange}
            />
          </div>
        </BlockStack>
      </Modal.Section>
    </Modal>

    const EditHoursModal = <Modal
      open={editHoursState}
      title={t("Edit business hours")}
      primaryAction={{
        content: t("Save"),
        onAction: this.updateStructuredData,
        loading: firstSaveButtonLoading,
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: this.toggleHoursEdit
        }
      ]}
      onClose={this.toggleHoursEdit}
    >
      <Modal.Section>
        <BlockStack gap={200}>
          <div className="flex_layout" style={{ justifyContent: 'space-between' }}>
            <span>{t("Monday")}</span>
            <div className='Content-Item flex_layout'>
              <TextField
                type="time"
                disabled={false}
                value={mon_time.am}
                id="mon_time.am"
                onChange={this.handleCheckInputChange}
              />
              <TextField
                type="time"
                disabled={false}
                value={mon_time.pm}
                id="mon_time.pm"
                onChange={this.handleCheckInputChange}
              />
            </div>
          </div>
          <div className="flex_layout" style={{ justifyContent: 'space-between' }}>
            <span>{t("Tuesday")}</span>
            <div className='Content-Item flex_layout'>
              <TextField
                type="time"
                disabled={false}
                value={tue_time.am}
                id="tue_time.am"
                onChange={this.handleCheckInputChange}
              />
              <TextField
                type="time"
                disabled={false}
                value={tue_time.pm}
                id="tue_time.pm"
                onChange={this.handleCheckInputChange}
              />
            </div>
          </div>
          <div className="flex_layout" style={{ justifyContent: 'space-between' }}>
            <span>{t("Wednesday")}</span>
            <div className='Content-Item flex_layout'>
              <TextField
                type="time"
                disabled={false}
                value={wed_time.am}
                id="wed_time.am"
                onChange={this.handleCheckInputChange}
              />
              <TextField
                type="time"
                disabled={false}
                value={wed_time.pm}
                id="wed_time.pm"
                onChange={this.handleCheckInputChange}
              />
            </div>
          </div>
          <div className="flex_layout" style={{ justifyContent: 'space-between' }}>
            <span>{t("Thursday")}</span>
            <div className='Content-Item flex_layout'>
              <TextField
                type="time"
                disabled={false}
                value={thu_time.am}
                id="thu_time.am"
                onChange={this.handleCheckInputChange}
              />
              <TextField
                type="time"
                disabled={false}
                value={thu_time.pm}
                id="thu_time.pm"
                onChange={this.handleCheckInputChange}
              />
            </div>
          </div>
          <div className="flex_layout" style={{ justifyContent: 'space-between' }}>
            <span>{t("Friday")}</span>
            <div className='Content-Item flex_layout'>
              <TextField
                type="time"
                disabled={false}
                value={fri_time.am}
                id="fri_time.am"
                onChange={this.handleCheckInputChange}
              />
              <TextField
                type="time"
                disabled={false}
                value={fri_time.pm}
                id="fri_time.pm"
                onChange={this.handleCheckInputChange}
              />
            </div>
          </div>
          <div className="flex_layout" style={{ justifyContent: 'space-between' }}>
            <span>{t("Saturday")}</span>
            <div className='Content-Item flex_layout'>
              <TextField
                type="time"
                disabled={false}
                value={sat_time.am}
                id="sat_time.am"
                onChange={this.handleCheckInputChange}
              />
              <TextField
                type="time"
                disabled={false}
                value={sat_time.pm}
                id="sat_time.pm"
                onChange={this.handleCheckInputChange}
              />
            </div>
          </div>
          <div className="flex_layout" style={{ justifyContent: 'space-between' }}>
            <span>{t("Sunday")}</span>
            <div className='Content-Item flex_layout'>
              <TextField
                type="time"
                disabled={false}
                value={sun_time.am}
                id="sun_time.am"
                onChange={this.handleCheckInputChange}
              />
              <TextField
                type="time"
                disabled={false}
                value={sun_time.pm}
                id="sun_time.pm"
                onChange={this.handleCheckInputChange}
              />
            </div>
          </div>
        </BlockStack>
      </Modal.Section>
    </Modal>

    // Local Card
    const localBuinessCard = <Card>
      <BlockStack gap={400}>
        <div className='card_top'>
          <div className='card_state'>
            <Text variant="headingMd" as="h2">{t("Local Business")}</Text>
            {
              localBusinessStatus ? <Badge tone='success'>{t("On")}</Badge> : <Badge>{t("Off")}</Badge>
            }
            <div className='org_switch'>
              {loadingSwitch && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
              <Switch disabled={loadingSwitch} onChange={() => this.switchOragnizeState('localBusinessStatus')} checked={localBusinessStatus} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
            </div>
          </div>
          <Text as="p" tone="subdued" variant='bodyMd'>
            {t("The local pack shows businesses like restaurants, hotels, shops, and service providers based on the user’s search and location. However, not all local businesses appear, as Google uses various factors to determine visibility. You can use the")}
            <Button variant="plain" onClick={this.jumpOutUrl}>&nbsp;{t("Google Rich Results Test")}&nbsp;</Button>
            {t("to validate it.")}
          </Text>
        </div>
        <div className='local_detail'>
          <div className='local_img'>
            <div className='flex_layout'>
              <Thumbnail
                source={image_url || NoteMajor}
                size="small"
                alt=""
              />
            </div>
            <div className='local_img_text'>
              <p className='Every_Card_Text'>{business_name || t("Business name")}</p>
              <span>{streetAddress || '-'} {addressLocality || '-'}, {postalCode || '-'} {addressRegion || '-'}, {addressCountry || '-'}</span>
            </div>
          </div>
          <div className='local_tude'>
            <div className='flex_layout'>
              <p className='Every_Card_Text'>{t("Latitude and Longitude")}</p>
              {
                !latitude && !longitude ? <Badge>{t("Not add")}</Badge> : null
              }
            </div>
            {
              !latitude && !longitude ? null : <span>{latitude || '-'}, {longitude || '-'}</span>
            }
          </div>
          <div className='local_edit'>
            <Popover
              active={localState}
              activator={<span className="cp-close" onClick={() => {
                this.setState({
                  localState: !localState
                })
              }}><Icon source={MobileHorizontalDotsMajor} color='base' /></span>}
              autofocusTarget="first-node"
              onClose={() => {
                this.setState({
                  localState: false
                })
              }}
            >
              <ActionList
                actionRole="menuitem"
                items={[
                  {
                    content: t("Edit"),
                    onAction: () => this.toggleStoreEdit()
                  }
                ]}
              />
            </Popover>
          </div>
        </div>
        <div className='local_params'>
          <TextField
            type="tel"
            label={t("Telephone")}
            value={telephone}
            id="telephone"
            onChange={this.handleInputChange}
          />
          <TextField
            type="text"
            label={t("Price range")}
            value={price_range}
            id="price_range"
            onChange={this.handleInputChange}
          />
          <TextField
            type="text"
            label={t("Review rating")}
            value={review_rating}
            id="review_rating"
            onChange={this.handleInputChange}
          />
          <Select
            label={t("Local Business @type")}
            options={localTypeOoptions}
            id="local_business_type"
            onChange={this.handleLocalBusinessTypeInputChange}
            value={local_business_type ? local_business_type : localTypeOoptions[0]}
          />
        </div>
        <div className='local_hours'>
          <div className='local_time'>
            <p className='Every_Card_Text'>{t("Business hours")}</p>
            <span>{`${t("Monday")}: ${mon_time.am} - ${mon_time.pm}, ${t("Tuesday")}: ${tue_time.am} - ${tue_time.pm}, ${t("Wednesday")}: ${wed_time.am} - ${wed_time.pm}, ${t("Thursday")}: ${thu_time.am} - ${thu_time.pm}, ${t("Friday")}: ${fri_time.am} - ${fri_time.pm}`}</span>
          </div>
          <Popover
            active={timeState}
            activator={<span className="cp-close" onClick={() => {
              this.setState({
                timeState: !timeState
              })
            }}><Icon source={MobileHorizontalDotsMajor} color='base' /></span>}
            autofocusTarget="first-node"
            onClose={() => {
              this.setState({
                timeState: false
              })
            }}
          >
            <ActionList
              actionRole="menuitem"
              items={[
                {
                  content: t("Edit"),
                  onAction: () => this.toggleHoursEdit()
                }
              ]}
            />
          </Popover>
        </div>
        {/* <div className='card_left_opera'>
          <LocalBusinessForms resData={resData} show={this.props.show} />
        </div> */}
      </BlockStack>
    </Card>

    const titlePages = <div className='title-font-style'>
      {this.state.showBanner ? <div style={{ marginTop: 24 }}>
        <Banner
          title="Tip"
          tone="critical"
          onDismiss={() => {
            this.setState({
              showBanner: false,
            })
          }}
        >
          <div className='jsonldBannerContent'>
            <span>{t("Before displaying structured data, please enable the APP embed block,")}&nbsp;<Link url={this.state.clickHereUrl} external={true}>{t("Click here")}</Link>&nbsp;{t("to open it.")}</span>
            <div onClick={() => this.toggleDocModalActive(false)} className='jsonldBannerSpan'>
              <span>{t("view doc")}</span>
              <Icon source={ArrowRightMinor} />
            </div>
          </div>
        </Banner>
      </div> : null}
    </div>

    const docModal = <div>
      <Modal
        size='large'
        open={this.state.docModalStatus}
        onClose={this.toggleDocModalActive}
      >
        <Modal.Section>
          <div style={{ padding: '2rem' }}>
            <p>Step 1: Click [click here] in the tips column of the Google Structured Data - Snippets page to jump to the shopify online store-APP embeds page</p>
            <img src="/imgJsonLD/step1.png" className="pcStep1Img" alt="step1.png" />
            <img src="/imgJsonLD/mstep1.png" className="mobileStep1Img" alt="step1.png" />
            <p>Step 2: In shopify online store-APP embeds page, You can see Open the APP embeds of SEOAnt JSON-LD by default, just click the save button in the upper right corner, and you can use the structured data display after returning to the page</p>
            <img src="/imgJsonLD/step2.png" className="pcStep2Img" alt="step2.png" />
            <img src="/imgJsonLD/mstep2.png" className="mobileStep2Img" alt="step2.png" />
          </div>
        </Modal.Section>
      </Modal>
    </div>

    // 常见问题
    const FrequentlyItems = <FaqCardBox FaqList={questionList} hasImg={"/imgJsonLD/local-business03.png"} />

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 等级
    // const lockIcon = (plan = 1) => {
    //   return <div className='PAY_ICON'>
    //     {plan === 2 ? t("Pro plan unlock") : t("Pre plan unlock")} <Icon source={LockMajor} tone="base" />
    //   </div>
    // }

    // 最终内容
    var pageContentLast = this.state.loadingPage ? <SkeltonLoading /> :
      <Page
      // title={<div className='pageLayout' style={{ display: "flex", alignItems: "center" }}>
      //   {t("Local Business")}&nbsp;
      //   <Tooltip content={t("Enrich your backlink profile in the least effort to increase your domain authority. Gain peace of mind that all backlinks are built naturally to avoid Google penalties.")}>
      //     {<Icon backdrop source={QuestionMarkInverseMajor} />}
      //   </Tooltip>
      //   {(level === 1 && false) && lockIcon(2)}
      // </div>}
      // backAction={{
      //   content: t("Local Business"), 
      //   onAction: this.goBack,
      // }}
      >

        <title>SEOAnt - Local Business</title>

        {/* <div className='correctly_tip' style={{ marginBottom: '1rem' }}>
          {t("To ensure that the Local Business is working correctly, you can")}&nbsp;
          <span onClick={this.jumpOutUrl}>{t("use the Google Rich Results Test to validate it.")}</span>
        </div> */}

        <SaveBarTop
          isShowSaveBar={isShowSaveBar}
          saveLoading={firstSaveButtonLoading}
          handleSaveAction={this.updateStructuredData}
          handleDiscardAction={this.handleShopifyDiscard}
        />

        {titlePages}
        {docModal}

        <BlockStack gap={400}>
          <div className='localbuiness_card_list'>
            {localBuinessCard}
          </div>
          {FrequentlyItems}
        </BlockStack>
        {/* 底部 */}
        {FooterHelpBox}
      </Page>
    return (
      <div>
        {pageContentLast}
        {
          Boolean(imgUrl) && <ViewImage imgUrl={imgUrl} closeImageShow={this.closeImageShow} />
        }
        {EditStoreModal}
        {EditHoursModal}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => ({
  // 判断是否页面第一次loading
  getPageDataRedux(data) {
    dispatch(setPageData(['LocalBusiness', data]));
  },
})

indexClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);